// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.custom-header {\n\tborder-bottom: 1px solid #eaeefb;\n\tmargin-bottom: 1em;\n\tpadding-bottom: 0.5em;\n}\n.custom-title {\n\tmargin: 0;\n\tpadding-top: 0.25em;\n}\n", ""]);
// Exports
module.exports = exports;
